// SearchFlix.jsx
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import SearchFlixList from '../container/SearchFlixList.js';

import Loading from '../component/Loading.jsx';

import { TranslationNamespace } from '../resource/translationNamespace.js';

import { textColor } from '../style/variables.js';

import EmptyResultIconResource from '../../img/img-empty-nofollowing.svg';

export class SearchFlix extends React.PureComponent {
  fetchData = () => {
    const {
      sortingString,
      query,
      defaultFlixCategory,
      hasQuery,
      isActive,
      fetchMessageSearch,
      fetchFeeds,
    } = this.props;
    if (!isActive) {
      return;
    }
    if (hasQuery) {
      return fetchMessageSearch({
        query,
        type: 'flix',
        sortings: sortingString.split('&').filter(i => i),
      });
    }
    return fetchFeeds({
      type: defaultFlixCategory,
    });
  };
  componentDidMount() {
    const { isFlixFetched } = this.props;
    if (!isFlixFetched) {
      this.fetchData();
    }
  }
  componentDidUpdate(prevProps) {
    const { query, isAuthed, isActive, sortingString } = this.props;
    if (
      isAuthed !== prevProps.isAuthed ||
      query !== prevProps.query ||
      isActive !== prevProps.isActive ||
      sortingString !== prevProps.sortingString
    ) {
      this.fetchData();
    }
  }
  render() {
    const { type, category, isFlixFetched, flixIds, t } = this.props;
    if (flixIds.length === 0) {
      if (!isFlixFetched) {
        // only show loading when list is empty to prevent scroll height loss.
        return (
          <StyledSearchFlix>
            <LoadingWrapper>
              <Loading />
            </LoadingWrapper>
          </StyledSearchFlix>
        );
      }
      return (
        <StyledSearchFlix>
          <EmptyResultWrapper>
            <EmptyResultIcon src={EmptyResultIconResource} />
            {t('search_no_result', {
              ns: TranslationNamespace.SEARCH,
            })}
          </EmptyResultWrapper>
        </StyledSearchFlix>
      );
    }
    return (
      <StyledSearchFlix>
        <SearchFlixList type={type} category={category} />
      </StyledSearchFlix>
    );
  }
}

SearchFlix.propTypes = {
  sortingString: PropTypes.string,
  query: PropTypes.string,
  type: PropTypes.string,
  category: PropTypes.string,
  defaultFlixCategory: PropTypes.string,
  isAuthed: PropTypes.bool,
  isFlixFetched: PropTypes.bool,
  hasQuery: PropTypes.bool,
  isActive: PropTypes.bool,
  flixIds: PropTypes.array,
  fetchFeeds: PropTypes.func,
  fetchMessageSearch: PropTypes.func,
  t: PropTypes.func.isRequired,
};

SearchFlix.defaultProps = {
  sortingString: '',
  query: '',
  type: '',
  category: '',
  defaultFlixCategory: '',
  isAuthed: false,
  isFlixFetched: false,
  hasQuery: false,
  isActive: false,
  flixIds: [],
  fetchFeeds: () => null,
  fetchMessageSearch: () => null,
};

const StyledSearchFlix = styled.div``;

const LoadingWrapper = styled.div`
  margin-top: 52px;
`;

const EmptyResultWrapper = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${textColor.black};
  font-size: 14px;
`;

const EmptyResultIcon = styled.img`
  margin-bottom: 12px;
  height: 120px;
  width: auto;
`;

export default withTranslation()(SearchFlix);
